import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TwitchOutlinedSvg from "@ant-design/icons-svg/es/asn/TwitchOutlined";
import AntdIcon from "../components/AntdIcon";
var TwitchOutlined = function TwitchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitchOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TwitchOutlined.displayName = 'TwitchOutlined';
}
export default /*#__PURE__*/React.forwardRef(TwitchOutlined);